/* GOWin® Store — disponibilidad inmediata v1: mostrar el límite desde la primera respuesta de Shopify */
(() => {
  'use strict';
  if (window.GowinCartAvailabilityFastV1) return;
  window.GowinCartAvailabilityFastV1 = true;

  const ROW = '.cart-item';
  const REAL_INPUT = '.cart-item__quantity .quantity__input';
  const ERROR = '.cart-item__error';
  const ERROR_TEXT = '.cart-item__error-text';
  const QUANTITY_CONTROL = [
    'select.gowin-cart-qty-inline__select',
    '.gowin-cart-qty-inline__custom',
    REAL_INPUT,
  ].join(',');

  const stickyMessages = new Map();
  let observer;

  const lineKey = (row) => {
    if (!row) return '';
    const input = row.querySelector(REAL_INPUT);
    if (input?.dataset?.index) return String(input.dataset.index);
    const match = String(row.id || '').match(/CartDrawer-Item-(\d+)/);
    return match?.[1] || '';
  };

  const partsFor = (row) => {
    const details = row?.querySelector('.cart-item__details');
    const error = row?.querySelector(ERROR);
    const text = error?.querySelector(ERROR_TEXT);
    return { details, error, text };
  };

  const showMessage = (row, message) => {
    const value = String(message || '').trim();
    if (!row || !value) return;

    const { details, error, text } = partsFor(row);
    if (!error || !text) return;
    if (details && error.parentElement !== details) details.appendChild(error);

    if (text.textContent !== value) text.textContent = value;
    error.dataset.gowinErrorActive = 'true';
    error.classList.add('gowin-cart-item-error-visible', 'is-visible');
    error.setAttribute('aria-hidden', 'false');
  };

  const clearMessage = (row) => {
    const { error, text } = partsFor(row);
    if (!error || !text) return;
    text.textContent = '';
    error.dataset.gowinErrorActive = 'false';
    error.classList.remove('is-visible');
    error.setAttribute('aria-hidden', 'true');
  };

  const availabilityQuantityFromMessage = (message) => {
    const value = String(message || '').replace(/\s+/g, ' ').trim();
    if (!value) return null;

    const patterns = [
      /\bsolo\s+se\s+(?:añadieron|agregaron)\s+(\d+)\s+(?:artículos|articulos|productos|unidades)\b/i,
      /\bsolo\s+(?:puedes|puede)\s+(?:añadir|agregar|comprar|tener)\s+(\d+)\b/i,
      /\bonly\s+(\d+)\s+(?:items?|products?|units?)\s+(?:were\s+)?added\b/i,
      /\b(?:you\s+can\s+)?only\s+(?:add|have|buy)\s+(\d+)\b/i,
      /\b(\d+)\s+(?:items?|products?|units?|artículos|articulos|productos|unidades)\s+(?:are\s+)?(?:available|disponibles?)\b/i,
    ];

    for (const pattern of patterns) {
      const match = value.match(pattern);
      const quantity = parseInt(match?.[1] || '', 10);
      if (Number.isInteger(quantity) && quantity > 0) return quantity;
    }

    return null;
  };

  const primeAvailabilityQuantity = (row, message) => {
    const quantity = availabilityQuantityFromMessage(message);
    if (!row || quantity === null) return;

    const input = row.querySelector(REAL_INPUT);
    if (!input) return;

    const expected = String(quantity);
    input.value = expected;

    const custom = row.querySelector('.gowin-cart-qty-inline__custom');
    if (custom) custom.value = expected;

    const select = row.querySelector('select.gowin-cart-qty-inline__select');
    if (!select) return;

    let option = [...select.options].find((item) => item.value === expected);
    if (!option) {
      option = document.createElement('option');
      option.value = expected;
      option.textContent = expected;
      option.dataset.gowinRecoveryOption = 'true';
      select.appendChild(option);
    }

    select.value = expected;
    select.dataset.gowinQtySignature = '';
  };

  const captureErrorText = (textNode) => {
    if (!(textNode instanceof Element) || !textNode.matches(ERROR_TEXT)) return;
    const message = String(textNode.textContent || '').trim();
    if (!message) return;

    const row = textNode.closest(ROW);
    const key = lineKey(row);
    if (!row || !/^\d+$/.test(key)) return;

    /*
      Shopify ya devolvió el límite real. Sincronizar input + selector dentro de
      la misma microtarea evita que el rAF de feed-style llegue a pintar el
      valor anterior antes del segundo request de confirmación.
    */
    primeAvailabilityQuantity(row, message);
    stickyMessages.set(key, message);
    showMessage(row, message);
  };

  const inspectMutation = (mutation) => {
    const target = mutation.target instanceof Element ? mutation.target : mutation.target?.parentElement;
    if (target?.matches?.(ERROR_TEXT)) captureErrorText(target);

    mutation.addedNodes?.forEach?.((node) => {
      if (!(node instanceof Element)) return;
      if (node.matches(ERROR_TEXT)) captureErrorText(node);
      node.querySelectorAll?.(ERROR_TEXT).forEach(captureErrorText);
    });
  };

  const reapplyStickyMessages = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    if (!drawer.querySelector(ROW)) {
      stickyMessages.clear();
      return;
    }

    stickyMessages.forEach((message, key) => {
      const input = drawer.querySelector(`${REAL_INPUT}[data-index="${key}"]`);
      const row = input?.closest(ROW) || drawer.querySelector(`#CartDrawer-Item-${key}`);
      if (row) showMessage(row, message);
    });
  };

  const clearForControl = (control) => {
    const row = control?.closest?.(ROW);
    const key = lineKey(row);
    if (key) stickyMessages.delete(key);
    if (row) clearMessage(row);
  };

  const bind = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    observer?.disconnect();
    observer = new MutationObserver((mutations) => mutations.forEach(inspectMutation));
    observer.observe(drawer, { childList: true, subtree: true, characterData: true });
  };

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof Element) || !target.matches(QUANTITY_CONTROL)) return;
    clearForControl(target);
  }, true);

  document.addEventListener('click', (event) => {
    const remove = event.target?.closest?.('cart-remove-button, .cart-remove-button');
    if (remove) clearForControl(remove);
  }, true);

  document.addEventListener('gowin:cart-patched', () => {
    reapplyStickyMessages();
    requestAnimationFrame(reapplyStickyMessages);
  });

  document.addEventListener('shopify:section:load', bind);
  window.addEventListener('pageshow', bind);
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', bind, { once: true })
    : bind();
})();
